/**
 * Function to clear all inputs in a table filter
 * 
 * @param {string} elementClass css class name for the filter elements.
 * 
 * @returns void
 */
export const filterClear = (elementClass: string) => {
  const tableInputClear = Array.from(document.querySelectorAll<HTMLInputElement>(elementClass));

  tableInputClear.forEach(ele => {
    if(ele.type === 'date') {
      ele.value = '';
    } else if (ele.type === 'checkbox') {
      ele.checked = false;
    } else if (ele.type === 'radio') {
      ele.id === 'aafp_transaction-payment-type' ? ele.checked = true : ele.checked = false;
    } else if (ele.name === 'payment') {
      ele.value = '0';
    } else if (ele.type === 'number') {
      ele.value = '';
    } else if (ele.type === 'search') {
      ele.value = '';
    } else if (ele.type === 'text') {
      ele.value = '';
    } else if (ele.dataset.value) {
      ele.removeAttribute('data-value');
      ele.innerHTML = 'Please Select';
    }      
  });
}